<template>
    <svg
        width="8"
        height="6"
        viewBox="0 0 8 6"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <g clip-path="url(#clip0_2309_304)">
            <path
                d="M3.58252 5.36753C3.78014 5.66704 4.21957 5.66704 4.41719 5.36753L6.95234 1.5254C7.17169 1.19297 6.93328 0.750028 6.53501 0.750028H1.4647C1.06643 0.750028 0.828018 1.19297 1.04736 1.5254L3.58252 5.36753Z"
                fill="#333333"
            />
        </g>
        <defs>
            <clipPath id="clip0_2309_304">
                <rect width="8" height="6" fill="white" />
            </clipPath>
        </defs>
    </svg>
</template>
<script>
export default {
    name: "TriangleDownIcon",
};
</script>
